import { deleteDocument } from "../../../api/social";
import { showToastError, showToastSuccess } from "../../../services/toast";
import { useSocialStore } from "../../../stores/social";
import { useTranslation } from "react-i18next";
import {
  ModalButton,
  ModalConfirmText,
  ModalShell,
} from "../../ui/modals/ModalShell";

const DeleteDocs = ({ closeModal, idDoc }: any) => {
  const { t } = useTranslation();
  const { updateSocial, setUpdateSocial } = useSocialStore();

  const handleSubmit = () => {
    deleteDocument(idDoc)
      .then(() => {
        showToastSuccess(t("Le document a été supprimé avec succès"));
        setUpdateSocial(!updateSocial);
        closeModal();
      })
      .catch(() => {
        showToastError(t("Erreur lors de la suppression du document"));
      });
  };

  return (
    <ModalShell
      title={t("Suppression")}
      size="sm"
      onClose={() => closeModal()}
      footer={
        <>
          <ModalButton variant="secondary" onClick={() => closeModal()}>
            {t("Annuler")}
          </ModalButton>
          <ModalButton variant="danger" onClick={handleSubmit}>
            {t("Supprimer")}
          </ModalButton>
        </>
      }
    >
      <ModalConfirmText>
        {t("Souhaitez vous vraiment supprimer le document ?")}
      </ModalConfirmText>
    </ModalShell>
  );
};

export default DeleteDocs;
